/**
 * Invoice Template Index Route
 * Redirects to gallery
 */

import { useEffect } from 'react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/dashboard/invoice-template/')({
  component: InvoiceTemplateIndex,
})

function InvoiceTemplateIndex() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate({ to: '/dashboard/settings/invoice-templates' })
  }, [navigate])

  return null
}
